import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-form-rejection-success-modal',
  templateUrl: './form-rejection-success-modal.component.html',
  styleUrls: ['./form-rejection-success-modal.component.scss']
})
export class FormRejectionSuccessModalComponent {

  
  public data: any;  

  constructor(protected dialogRef: NbDialogRef<any>) {
    this.data = this.dialogRef;  
  }

  reject() {
    this.dialogRef.close(true); // Pass true to indicate approval
  }





}
